import { render } from "./DitRaaderumCalculatorResultCard.vue?vue&type=template&id=99c4ac36"
import script from "./DitRaaderumCalculatorResultCard.vue?vue&type=script&lang=js"
export * from "./DitRaaderumCalculatorResultCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__